import React from 'react'

import '@/components/Alert/FlashMessage/FlashMessage.scss'

export default function FlashMessage({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="c-alert-flashMessage">{children}</div>
    </>
  )
}
